module.exports = __webpack_public_path__ + "static/media/background_3.c33ca8eb.jpg";